<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
  export default {
    name: 'GuestBooking',
  };
</script>

<style scoped>

</style>